import styled from 'styled-components';

export const ControlsWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	flex-grow: 1;
`;
